import React, { useEffect } from "react";

const NavMenu = () => {
  useEffect(() => {
    // Плавный скролл по якорям
    const handleAnchorClick = (e) => {
      const targetId = e.target.getAttribute("href");
      if (targetId && targetId.startsWith("#")) {
        e.preventDefault();
        const element = document.querySelector(targetId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    };

    const links = document.querySelectorAll(".nav-menu__list-item a");
    links.forEach((link) => link.addEventListener("click", handleAnchorClick));

    // Подсветка активного пункта при скролле
    const handleScroll = () => {
      const sections = document.querySelectorAll("section[id]");
      let current = "";
      sections.forEach((section) => {
        const sectionTop = section.offsetTop;

        if (window.pageYOffset >= sectionTop - 100) {
          current = section.getAttribute("id");
        }
      });
      links.forEach((link) => {
        link.classList.remove("active");
        if (link.getAttribute("href").substring(1) === current) {
          link.classList.add("active");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // вызвать при монтировании

    return () => {
      links.forEach((link) =>
        link.removeEventListener("click", handleAnchorClick),
      );
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className="top-section1">
      <div className="container top-section__nav-container">
        <header className="top-section__header">
          <nav className="top-section__nav nav-menu">
            <ul className="nav-menu__list">
              <li className="nav-menu__list-item">
                <a href="#inputData">ВВОД ДАННЫХ</a>
              </li>
              <li className="nav-menu__list-item">
                <a href="#financialResults">ФИНАНСОВЫЕ РЕЗУЛЬТАТЫ</a>
              </li>
              <li className="nav-menu__list-item">
                <a href="#analyticsСharts">ГРАФИКИ</a>
              </li>
              <li className="nav-menu__list-item">
                <a href="#investment">ВЛОЖЕНИЯ</a>
              </li>
              <li className="nav-menu__list-item">
                <a href="#cashFlowSection">ДДС</a>
              </li>
              <li className="nav-menu__list-item">
                <a href="#lastElem">КАРТЫ</a>
              </li>
              <li className="nav-menu__list-item">
                <a href="#lastElem2">ОПИСАНИЕ</a>
              </li>
              <li className="nav-menu__list-item nav-menu__list-item--highlight">
                <a href="#b24-form-container">КОНТАКТЫ</a>
              </li>
            </ul>
          </nav>
        </header>
      </div>
    </section>
  );
};

export default NavMenu;
